<template lang="pug">
  v-card.sdo-card
    v-sheet(
      color="secondary"
      dark
    ).module--header.pa-5
      .shrink
        v-btn(
          color="#58566B"
          fab
          exact
          :to="{ name: 'ModulesManagementLead' }"
          depressed
        ).mr-3.shrink
          v-icon(color="white") mdi-close
      v-scroll-y-transition(leave-absolute)
        v-skeleton-loader(
          v-if="loading.moduleItem"
          type="list-item-two-line"
        ).grow
      div(v-if="!loading.moduleItem && moduleItem")
        .title.ellipsis {{ moduleItem.name }}
        .opacity Подписок: {{ $tc('organizations', moduleItem.accepted_users_count) }}
    v-row(no-gutters).module--nav.mx-5.mt-n1
        v-col(cols=12 sm=6 md=3)
          v-list-item(
            active-class="active-menu"
            :to="{ name: 'ModuleViewUnits' }"
          )
            v-list-item-title: strong Темы
        v-col(cols=12 sm=6 md=3)
          v-list-item(
            active-class="active-menu"
            :to="{ name: 'ModuleViewEscort' }"
          )
            v-list-item-title: strong Сопровождение
        v-col(cols=12 sm=6 md=3)
          v-list-item(
            active-class="active-menu"
            :to="{ name: 'ModuleViewSubscribers' }"
          )
            v-list-item-title: strong Подписки
        v-col(cols=12 sm=6 md=3)
          v-list-item(
            active-class="active-menu"
            :to="{ name: 'ModuleViewAnalytic' }"
          )
            v-list-item-title: strong Аналитика
        v-col(cols=12 sm=6 md=3)
          v-list-item(
            active-class="active-menu"
            :to="{ name: 'ModuleViewSettings' }"
          )
            v-list-item-title: strong  Настройки
        //- v-col(cols=12 sm=6 md=3)
        //-   v-list-item(
        //-     active-class="active-menu"
        //-     :to="{ name: 'ModuleGPTSettings' }"
        //-   )
        //-     v-list-item-title: strong  Нейросеть

    v-card-text.px-5
      router-view(
        v-if="!loading.moduleItem"
        :module-item="moduleItem"
      )
</template>

<script>
export default {
  data: () => ({
    moduleItem: null,

    loading: {
      moduleItem: true,
    },
  }),
  computed: {
    moduleId() {
      return this.$route.params.id;
    },
  },
  watch: {
    moduleId() {
      this.fetchModule();
    },
  },
  created() {
    this.fetchModule();
  },
  methods: {
    changeRoute(val) {
      const route = val ? 'ModuleGPTSettings' : 'ModuleViewSettings';
      this.$router.push({ name: route });
    },
    async fetchModule() {
      this.loading.moduleItem = true;
      const { item } = await this.$api.modules.show(
        this.$route.params.id, { expand: 'accepted_users_count,prior_records_exists,telegram' },
      );
      this.moduleItem = item;
      this.moduleItem.bind('onChange', (val) => {
        this.$emit('change:moduleItem', val);
      });
      this.loading.moduleItem = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.active-menu {
  background: #df7b1e !important;
  color: white !important;
}

.module {

  &--header {
    z-index: 1;
    display: flex;
    align-content: center;
  }
}
</style>
